import React, { useContext, useEffect, useMemo, useState } from 'react'
import * as classes from './Job.module.scss'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import splitRow from '../../../../utils/splitRow'
import { startAnimationScroll } from '../../../../utils/animations'
import { FormContext } from '../../../../context'
import splitTitleV2 from '../../../../utils/splitTitleV2'
import Container from '../../../ui/Container/Container'

function Job({ data, lang }) {
    const { animationStart } = useContext(FormContext)

    const titleOne = useMemo(() => deleteHtmlTag(data.jobTitle.value, 'p'), [])
    const textOne = useMemo(() => deleteHtmlTag(data.jobText.value, 'p'), [])
    const emailOne = useMemo(() => deleteHtmlTag(data.jobEmail.value, 'p'), [])
    const applyNow = useMemo(() => deleteHtmlTag(data.applyNow.value, 'p'), [])

    const jobImage = useMemo(() => data.jobImage?.image?.url, [data.jobImage])

    const [title, setTitle] = useState({
        top: titleOne
    })

    const classAnimationTitle = 'anime-title-job'
    const classAnimationText = 'anime-text-job'

    useEffect(() => {
        if (animationStart) {
            splitRow(classAnimationText)
            splitTitleV2(classAnimationTitle)
        }

        const observer = startAnimationScroll([
            { type: 'title', className: classAnimationTitle },
            { type: 'text', className: classAnimationText }
        ])

        return () => {
            if (observer) {
                observer.disconnect()
            }
        }
    }, [animationStart])

    return (
        <section className={classes.Top}>
            <Container>
                <div className={classes.Inner}>
                    <div className={classes.Content}>
                        {title.top ? (
                            <h2 className={`${classes.Title} ${classAnimationTitle}`} dangerouslySetInnerHTML={{ __html: title.top }} />
                        ) : null}

                        {textOne ? (
                            <p
                                className={`${classes.Text} ${classAnimationText}`}
                                data-lang={lang}
                                dangerouslySetInnerHTML={{ __html: `${textOne} ${emailOne}` }}
                            />
                        ) : null}

                        {emailOne ? (
                            <a className={classes.Btn} href={`mailto:${emailOne}`} dangerouslySetInnerHTML={{ __html: applyNow }} />
                        ) : null}
                    </div>

                    <div className={classes.ImageWrap} style={{ backgroundImage: `url(${jobImage})` }} />
                </div>
            </Container>
        </section>
    )
}
export default Job
